/**
 * Copyright (C) 2025 GIP-RECIA, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function calculateScrollbarWidth(_: Event): void {
  document.documentElement.style.setProperty(
    '--scrollbar-width',
    `${window.innerWidth - document.documentElement.clientWidth}px`,
  )
}

function addScrollbarWidthListeners(): void {
  document.addEventListener('DOMContentLoaded', calculateScrollbarWidth, false)
  window.addEventListener('resize', calculateScrollbarWidth, false)
  window.addEventListener('load', calculateScrollbarWidth)
}

function removeScrollbarWidthListeners(): void {
  document.removeEventListener('DOMContentLoaded', calculateScrollbarWidth, false)
  window.removeEventListener('resize', calculateScrollbarWidth, false)
  window.removeEventListener('load', calculateScrollbarWidth)
}

function injectStyle(id: string, content: string): void {
  let style = document.head.querySelector<HTMLStyleElement>(`style#${id}`)
  if (style)
    return

  style = document.createElement('style')
  style.id = id
  style.textContent = content
  document.head.appendChild(style)
  window.addEventListener('load', () => {
    document.body.classList.add('transition-active')
  })
}

export {
  addScrollbarWidthListeners,
  injectStyle,
  removeScrollbarWidthListeners,
}
